import { auditFixtureState } from './routeStateContract';

export const CORE_JOURNEY_RELEASE_FIXTURES = {
  explore: 'explore-populated',
  scheduling: 'scheduling-populated',
  'degree-planning': 'degree-planning-populated',
} as const;

export type CoreJourneyReleaseRoute = keyof typeof CORE_JOURNEY_RELEASE_FIXTURES;

export function resolveCoreJourneyReleaseFixture(
  route: CoreJourneyReleaseRoute,
  requestedFixture: string | null | undefined,
  environment: NodeJS.ProcessEnv = process.env,
): 'populated' | null {
  if (requestedFixture !== CORE_JOURNEY_RELEASE_FIXTURES[route]) return null;
  return auditFixtureState('populated', environment) === 'populated' ? 'populated' : null;
}
